import { DefaultState, IState } from "./state";
import { Keys, Types } from "./actions/types";
import { birthday } from "../../../model/birthday";

export const reducer = (state: IState = DefaultState(), action: Types): IState => {
    switch (action.type) {
        case Keys.LOAD_PENDING: {
            return {
                ...state,
                birthdays: [],
                isLoadingBirthdays: true,
            }
        }
        case Keys.LOAD_FULFILLED: {
            let p: Array<birthday> = action.payload;
            return {
                ...state,
                birthdays: p,
                isLoadingBirthdays: false,
            }
        }
        case Keys.LOAD_REJECTED: {
            return {
                ...state,
                birthdays: [],
                isLoadingBirthdays: false,
            }
        }
        default:
            return state;
    }
}